function warn(message) {
  return window.o_global?.debug?.warn(message);
}
function sendCustomRequest(type, data) {
  if (typeof window.AS?.RUM?.sendCustomRequest === "function") {
    window.AS.RUM.sendCustomRequest(type, data);
  }
}
function deprecated(funcId, message = "") {
  const { stack } = Error("");
  warn(`${funcId} is deprecated, ${message}.`);
  sendCustomRequest("assets-legacy", {
    message: `${funcId}: ${message}`,
    stack,
    caller: stack?.split("\n")[2]
  });
}
function dateNow() {
  return /*           */ new Date();
}
function getTime() {
  return dateNow().getTime();
}
function now() {
  return Date.now();
}
function random() {
  return Math.random();
}

export { dateNow as a, deprecated as d, getTime as g, now as n, random as r, sendCustomRequest as s, warn as w };
/*                                 */
